module.exports = __webpack_public_path__ + "static/img/guidance1.5580e8f8.png";